import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
var SETTINGS_PATH = '/czna-authorities/settings';
/**
 * Navigation button for the form-config settings UI (TASK-180), rendered as a
 * sub-entry of the collapsible "Nastavení" submenu (CZNA-245). Labelled
 * "Nastavení formulářů" to disambiguate it from the submenu toggle itself.
 * Mirrors its sibling sub-entries exactly — same
 * buttonStyle/marginBottom0/aria-current contract — for a consistent look.
 *
 * The nav pane (rendered via `NavPaneLayout`) is intentionally kept visible
 * on the `/czna-authorities/settings` route so the user can navigate back to
 * Proposals/Authorities/Vocabularies/Imports without losing context.
 */
var SettingsNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var isActive = pathname === SETTINGS_PATH || pathname.startsWith("".concat(SETTINGS_PATH, "/"));
    var handleClick = useCallback(function () {
        if (pathname !== SETTINGS_PATH)
            history.push(SETTINGS_PATH);
    }, [history, pathname]);
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.formSettings' }))));
};
export default SettingsNavButton;
